import hexToRgba from "hex-rgba";
import { memoizedGet } from "@chakra-ui/utils";

const baseStyle = {
  border: "none",
  borderRadius: "18px",
  fontWeight: 600,
  lineHeight: 1.17,
  transition: "all 200ms ease",
  px: "24px",
  py: "11px",
  fontSize: "1.2rem",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none",
    pointerEvents: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
};

const containedPrimary = {
  color: "white",
  bg: "primaryBackground",
  _hover: {
    bg: "primaryLighter"
  },
  _active: {
    bg: "primaryDarker"
  }
};

const containedSecondary = {
  color: "white",
  bg: "secondary",
  _hover: {
    bg: "secondaryLighter"
  },
  _active: {
    bg: "secondaryDarker"
  }
};

const flatPrimary = {
  letterSpacing: "0.15px",
  color: "primary",
  bg: "transparent",
  _hover: {
    bg: "primaryLight"
  },
  _active: {
    bg: "primaryLight2"
  }
};

const flatSecondary = {
  letterSpacing: "0.15px",
  color: "secondary",
  bg: "transparent",
  _hover: {
    bg: "secondaryLight"
  },
  _active: {
    bg: "secondaryLight2"
  }
};

const flatLight = {
  letterSpacing: "0.15px",
  color: "white",
  bg: "transparent",
  _hover: {
    bg: "white20"
  },
  _active: {
    bg: "white30"
  }
};

const outlinedPrimary = ({ theme }) => ({
  letterSpacing: "-0.2px",
  border: "solid 1px",
  color: "primary",
  borderColor: hexToRgba(memoizedGet(theme, "colors.primary"), 40),
  bg: "transparent",
  _hover: {
    bg: "primaryLight"
  },
  _active: {
    bg: "primaryLight2"
  }
});

const outlinedSecondary = ({ theme }) => {
  return {
    letterSpacing: "-0.2px",
    border: "solid 1px",
    color: "secondary",
    borderColor: hexToRgba(memoizedGet(theme, "colors.secondary"), 40),
    bg: "transparent",
    _hover: {
      bg: "secondaryLight"
    },
    _active: {
      bg: "secondaryLight2"
    }
  };
};

const variants = {
  containedPrimary,
  containedSecondary,
  flatPrimary,
  flatSecondary,
  flatLight,
  outlinedPrimary,
  outlinedSecondary,
  custom: {}
};

const defaultProps = {
  variant: "containedPrimary"
};

const button = {
  baseStyle,
  variants,
  defaultProps
};

export default button;
